<template>
    <VueEditor
        :id="editorId"
        :value="content"
        :editor-toolbar="customToolbar"
        :editor-options="editorOptions"
        use-custom-image-handler
        @image-added="handleImageAdded"
        @input="handleInput"
    />
</template>
<script>
import { VueEditor } from 'vue2-editor'
import 'vue2-editor/dist/vue2-editor.css'
import axios from 'axios'

export default {
    name: 'editor_quill',
    props: {
        value: {
            type: String,
            default: ''
        },
        editorId: {
            type: String,
            default: () => 'editor-' + Math.random().toString(36).substr(2, 9)
        }
    },
    components: {
        VueEditor
    },
    data () {
        return {
            content: this.value || '',
            customToolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ header: [1, 2, 3, false] }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: [] }],
                ['link', 'image'],
                ['clean']
            ],
            editorOptions: {
                placeholder: 'Tulis konten di sini...'
            }
        }
    },
    watch: {
        value (newVal) {
            if (newVal !== this.content) {
                this.content = newVal || ''
            }
        }
    },
    methods: {
        handleInput (val) {
            this.content = val
            this.$emit('input', val)
        },
        handleImageAdded (file, Editor, cursorLocation, resetUploader) {
            const formData = new FormData()
            formData.append('file', file)

            const baseUrl = process.env.VUE_APP_API_URL
            const token = localStorage.getItem('token')

            axios.post(baseUrl + 'tinymce_upload', formData, {
                headers: {
                    'token': token,
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
                    const url = data.location || data.url
                    if (url) {
                        Editor.insertEmbed(cursorLocation, 'image', url)
                    }
                    resetUploader()
                })
                .catch((err) => {
                    console.error('Image upload failed:', err)
                    resetUploader()
                })
        }
    }
}
</script>
<style scoped>
>>> .quillWrapper {
    min-height: 300px;
}
>>> .ql-container {
    min-height: 250px;
}
</style>
